export default "__VITE_ASSET__CMUrARQt__"